const QUERIES = {
  USERS_LIST: 'users-list',
  PERMISSIONS_LIST: 'permissions-list',
}

export {QUERIES}
